import React from 'react';
import skinsStyles from './styles/LineBottomScreen.scss';
import BaseScreenSkin, { BaseScreenSkinProps } from './BaseScreenSkin';

const LineBottomScreen: React.FC<
  Omit<BaseScreenSkinProps, 'skin' | 'skinStyles'>
> = props => <BaseScreenSkin {...props} skinStyles={skinsStyles} />;

export default LineBottomScreen;
